export default __webpack_public_path__ + "static/media/img (2).0ef3cb1d.jpg";